// Profile.js
import React from "react";
import { socialLinks } from "./data"; // Import socialLinks data

const Profile = () => {
  return (
    <div className="profile">
      <img
        src="assets/img/profile-img.jpg"
        alt="Profile"
        className="img-fluid rounded-circle profile-img"
      />
      <h1 className="text-light">
        <a href="index.html">Ashmin Karki</a>
      </h1>
      <div className="social-links mt-3 text-center">
        {socialLinks.map(({ id, url, icon, title }) => (
          <a
            href={url}
            className={title}
            key={id}
            target="_blank"
            rel="noreferrer"
          >
            <i className={`bi ${icon}`} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default Profile;
